/**
 * Created by Tiger on 09/06/2022.
 */
import React, {FC, useState} from "react";
import styled from "@emotion/styled";
import {Image, PlusImage, PrimaryButton, SecondaryButton} from "./lib";
import {Button} from "antd";
import i18n from "i18next";

interface AuthProps {
  onConsent: () => void;
  onCancel: () => void
}

const Auth: FC<AuthProps> = ({onConsent, onCancel}) => {
  const [loading, setLoading] = useState(false);
  return (
    <Container>
      <div>
        <PlusImage/>
      </div>
      <Column>
        <h3>{i18n.t('auth_tip')}</h3>
        <p>
          {i18n.t('auth_tip2')}
        </p>
        <p>
          {i18n.t('google_privacy')} <Button type={"link"} href={'https://policies.google.com/privacy'}
                                             target={'_blank'}
                                             style={{margin: 0, padding: 0}}> {i18n.t('google_privacy2')}</Button>
          {i18n.t('an_end')}
        </p>
      </Column>

      <PrimaryButton loading={loading} style={{marginTop: 30}} type={"primary"} onClick={() => {
        setLoading(true)
        onConsent()
      }}>{i18n.t('confirm_auth')}</PrimaryButton>
      <SecondaryButton style={{marginTop: 30}} onClick={onCancel}>{i18n.t('cancel')}</SecondaryButton>

    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 80px 40px 0 40px;
  align-items: center;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`


export default Auth

